import React from "react";
import './account-addons-table.scss';
import {AddonStatuses, AddonStore} from "../../stores/addons-store-list";
import FontHeading4 from "../../../../../components/fonts/font-heading4/font-heading4";
import {FONT_COLOR, FONT_VARIANT} from "../../../../../components/fonts/font-props";
import FontBody2 from "../../../../../components/fonts/font-body2/font-body2";
import GridLineLayout from "../../../../../components/layouts/grid-line-layout/grid-line-layout";
import GridLine, {BackgroundColor} from "../../../../../components/layouts/grid-line-layout/grid-line/grid-line";
import GridLineItem from "../../../../../components/layouts/grid-line-layout/grid-line/grid-line-item/grid-line-item";
import {observer} from "mobx-react-lite";
import AHref from "../../../../../components/ahref/ahref";
import QuotaCounter from "../../../../../components/inputs/quota-counter/quota-counter";
import AddonQuotaCounter from "./components/addons-quota-counter/addons-quota-counter";
import AddonPrice from "./components/addon-price/addon-price";
import AddonStatus from "./components/addon-status/addon-status";
import AddonSwitcher from "./components/addons-switcher/addons-switcher";


const AccountAddonsTable: React.FC<{ addons: AddonStore[] }> = observer(({addons}) => {

    return (
        <div className="account-addons-table">
            <GridLineLayout>
                {addons.map((addon: AddonStore) =>
                    addon.addonStatus !== AddonStatuses.IncludedAsDeprecated &&
                    (!addon.deprecated || addon.addonStatus === AddonStatuses.Active) &&
                    <GridLine
                        key={addon.id}
                        backgroudColor={BackgroundColor.LIGHT}
                        settings={
                            {
                                columns: [
                                    {
                                        width: 1
                                    },
                                    {
                                        width: 1
                                    },
                                    {
                                        width: 0.7,
                                    },
                                    {
                                        width: 150,
                                        type: 'px'
                                    },
                                    {
                                        width: 100,
                                        type: 'px'
                                    },
                                ]
                            }
                        }
                        columns={[
                            <GridLineItem>
                                <div className="manage-addons-section-table-col-description">
                                    <div>
                                        <FontHeading4 color={FONT_COLOR.PRIMARY3} variant={FONT_VARIANT.BOLD}>
                                            {addon.displayName}
                                        </FontHeading4>
                                    </div>
                                    <div>
                                        <FontBody2>
                                            {addon.description}
                                        </FontBody2>
                                    </div>
                                    {addon.kbArticleLink &&
                                        <div>
                                            <AHref target={'_blank'} href={addon.kbArticleLink}>
                                                <FontBody2 variant={FONT_VARIANT.UNDER_LINE} color={FONT_COLOR.ACCENT1}>
                                                    More info
                                                </FontBody2>
                                            </AHref>
                                        </div>
                                    }
                                </div>
                            </GridLineItem>,
                            <GridLineItem>
                                <AddonStatus addon={addon}/>
                            </GridLineItem>,
                            <GridLineItem>
                                <AddonQuotaCounter addon={addon} addonName={addon.addonFeaturePluralName}/>
                            </GridLineItem>,
                            <GridLineItem>
                                <AddonPrice addon={addon} addonName={'user'}/>
                            </GridLineItem>,
                            <GridLineItem>
                                {addon.isQuotaBased() ?
                                    <QuotaCounter addon={addon}/> :
                                    <AddonSwitcher addon={addon}/>
                                }
                            </GridLineItem>
                        ]}
                    />
                )}
            </GridLineLayout>
        </div>
    )
});

export default AccountAddonsTable;